import React from 'react';
import { Alert } from 'reactstrap';
import AuthComponent from '../components/AuthComponent';
import gql from "graphql-tag";
import { Mutation } from "react-apollo";
import Spinner from '../components/Spinner';
import AnnounceModal from '../components/AnnounceModal'
// import ErrorModal from '../components/ErrorModal';
import CommonStore from '../components/CommonStore';
import { ColoredLine } from '../components/ColoredLine';
import ristorante from '../images/locandaDaLino.jpg';
import piatto from '../images/piatto.jpg';
import libro from '../images/libro.jpg';
import '../styles/LinkPage.css';

import { CURR_NUMSCHI, PREZZI } from '../constants'

import {
    Container, Card, CardBody,
    CardTitle, CardSubtitle, CardImg,
    Input, FormGroup, Form,
    Label, Row, Col, Button
} from 'reactstrap';

const GET_BOOKING_QUERY = gql`
  query getBooking($numschi: String!) {
    getBooking(numschi: $numschi)
  }
`
const SET_BOOKING_MUTATION = gql`
  mutation setBooking($numschi: String!, $booking: [Int!]!) {
    setBooking(numschi: $numschi, booking: $booking) {
        firstName
        lastName
        numschi
    }
  }
`
const GET_FAMILY_MEMBERS = gql`
  query getFamilyMembers($numschi: String!) {
    getFamilyMembers(numschi: $numschi) {
      numschi
      firstName
      lastName
      present
    }
  }
`

const SET_PRESENCE = gql`
  mutation setPresence($numschi: String!, $present: Int!) {
    setPresence(numschi: $numschi, present: $present) {
      numschi
    }
  }
`;

export default class BookingPage extends AuthComponent {
    constructor(props) {
        super(props);

        this.state = BookingPage.emptyState();
        
        this.currentNumschi = localStorage.getItem(CURR_NUMSCHI);

        this.processData = this.processData.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    static emptyState() {
        return {
            successMessage: false,
            present: 0,
            event1Adult: 0,
            event1Child: 0,
            event2Adult: 0,
            event2Child: 0,
            event3Adult: 0,
            event3Child: 0,
            countDish: 0,
            countBook: 0,
            mybooking: [],
            familyMembers: [],
            presenceMap: {},
            isMounted: false,
        }
    };

    processData(booking) {

        this.setState({
            present: booking[0] || 0,
            event1Adult: booking[1] || 0,
            event1Child: booking[2] || 0,
            event2Adult: booking[3] || 0,
            event2Child: booking[4] || 0,
            event3Adult: booking[5] || 0,
            event3Child: booking[6] || 0,
            countDish: booking[7] || 0,
            countBook: booking[8] || 0,
        });
    }

    handleChange(event) {
        const { name, type, value, checked } = event.target;
    
        this.setState({
            [name]: type === 'checkbox' ? checked : (value === '' ? 0 : parseInt(value, 10))
        });
    }
    normalizeBooking() {
        // Ensure no null or undefined values in the booking array
        return [
            this.state.present ? 1 : 0,
            this.state.event1Adult || 0,
            this.state.event1Child || 0,
            this.state.event2Adult || 0,
            this.state.event2Child || 0,
            this.state.event3Adult || 0,
            this.state.event3Child || 0,
            this.state.countDish || 0,
            this.state.countBook || 0,
        ];
    }

    componentWillUnmount() {
        this.setState({ isMounted: false })
    }
    componentDidMount() {
        this.setState({ isMounted: true }, () => {
            // Load your personal booking
            CommonStore.getApolloClient().query({
                fetchPolicy: 'no-cache',
                query: GET_BOOKING_QUERY,
                variables: {
                    numschi: this.currentNumschi
                }
            })
            .then(data => {
                console.log("Your booking:", data.data.getBooking);
                if (this.state.isMounted) {
                    this.processData(data.data.getBooking)
                }
            })
            .catch(error => console.error(error));
    
            // Load your family members
            CommonStore.getApolloClient().query({
                fetchPolicy: 'no-cache',
                query: GET_FAMILY_MEMBERS,
                variables: {
                    numschi: this.currentNumschi
                }
            })
            .then(data => {
                console.log("Family members:", data.data.getFamilyMembers);

                const presenceMap = {};
                data.data.getFamilyMembers.forEach(member => {
                    presenceMap[member.numschi] = member.present === 1;
                });

                if (this.state.isMounted) {
                    this.setState({ 
                    familyMembers: data.data.getFamilyMembers,
                    presenceMap: presenceMap
                });
                }
            })
            .catch(error => console.error(error));
        });
    }
    

    render() {

        return (
            <Container className="LinkPage" >
                <h4>LE TUE PRENOTAZIONI PER IL CLAN SCHIRATTI 2025</h4>
                <h6>In questa pagina puoi prenotare il libro ed i ristoranti. <br />
                Le prenotazioni sono <u>fondamentali per l'organizzazione del raduno</u>, perché ci permettono 
                di calcolare correttamente il numero dei partecipanti. 
                Alla fine della pagina, conferma le tue scelte premendo il bottone sotto la tabella con il totale dei costi. <br />
                Le <u>prenotazioni</u> vengono salvate sotto il tuo nome e possono essere modificate in qualsiasi momento, 
                <u> ma solo fino al 14 giugno</u>, data di scadenza. <br /><br />
                Dal 15 giugno, la lista definitiva sarà inoltrata agli addetti che provvederanno alla produzione del 
                libro e alle prenotazioni dei pranzi. <br /><br />
                Coccarde e libri verranno distribuiti all’arrivo dei partecipanti, in occasione dei pranzi e delle cene. 
                Allestiremo un banchetto per questo. Vieni ad iscriverti appena arrivato!! 
                Non dimenticare inoltre di confermare la tua presenza al raduno,
                in modo da poter essere inserito nella lista dei partecipanti e ricevere le informazioni necessarie.
                Per qualsiasi dubbio o domanda, contatta il nostro team di supporto (Francesca 654 e Cecilia 632).
                Grazie per la tua partecipazione e collaborazione!</h6>
                <AnnounceModal
                    title="Attenzione a tutti! Le prenotazioni sono definitive e non possono più essere modificate"
                    content="Scusate l'inconvenienza, ma non potete cambiare le vostre prenotazioni. Se proprio dovete modificare i pasti,
                     potete contattare me (Francesca 654). Vi ricordo che piatto e libro sono gia' in produzione e non possono essere modificati.
                     Grazie per la vostra comprensione!">
                </AnnounceModal>
                {(this.state.successMessage) && (
                    <div className="text-center mb-3">
                        <Alert color="success">
                        Prenotazione salvata con successo!
                        </Alert>
                    </div>
                )}

                        <Mutation mutation={SET_BOOKING_MUTATION}>
                            {(setBooking, { loading, error }) => {
                                if (loading) return (<Spinner />);
                                return (
                            <Form
                                onSubmit={event => {
                                    event.preventDefault();
                                    const normalizedBooking = this.normalizeBooking();
                                    this.setState({ mybooking: normalizedBooking }, () => {
                                      const userInput = {
                                        numschi: this.currentNumschi,
                                        booking: this.state.mybooking,
                                      };
                                  
                                      // 1. Submit booking
                                      setBooking({
                                        variables: userInput,
                                      }).then(() => {
                                        // 2. Presence updates
                                        const presencePromises = Object.entries(this.state.presenceMap).map(
                                          ([numschi, present]) =>
                                            CommonStore.getApolloClient().mutate({
                                              mutation: SET_PRESENCE,
                                              variables: {
                                                numschi,
                                                present: present ? 1 : 0
                                              }
                                            })
                                        );
                                  
                                        // 3. Wait for all updates, then refresh UI
                                        Promise.all(presencePromises)
                                          .then(() => {
                                            // ✅ Show success BEFORE refresh
                                            this.setState({ successMessage: true });
                                  
                                            // Wait briefly before fetching fresh data
                                            setTimeout(() => {
                                              this.componentDidMount();
                                              this.setState({ successMessage: false });
                                            }, 1000);  // 1s ensures DB catches up and Alert is seen
                                          })
                                          .catch(err => {
                                            console.error("Error updating presence", err);
                                          });
                                      });
                                    });
                                  }}
                                  
                                >

                                <Card>
                                    <CardBody>
                                        <CardTitle>Presenze Familiari al Raduno </CardTitle>
                                        <CardSubtitle>In questa lista sono elencati tutti i membri della tua famiglia.
                                            Cosi' per convenienza puoi segnare anche le loro presenze oltre alla tua.
                                        </CardSubtitle>
                                        {this.state.familyMembers.map((member) => (
                                        <FormGroup check key={member.numschi}>
                                            <Label check>
                                            <Input
                                                type="checkbox" disabled={true}
                                                checked={!!this.state.presenceMap[member.numschi]}
                                                onChange={(e) => {
                                                const updated = {
                                                    ...this.state.presenceMap,
                                                    [member.numschi]: e.target.checked
                                                };
                                                this.setState({ presenceMap: updated });
                                                }}
                                            />
                                            {member.firstName} {member.lastName} ({member.numschi})
                                            </Label>
                                        </FormGroup>
                                        ))}
                                    </CardBody>
                                </Card>

                                <Row className="section-panel">
                                    <Col>
                                        <Card>
                                            <CardImg width="100%" src={ristorante} alt="Card image cap" />
                                        </Card>
                                    </Col>
                                    <Col>
                                        <Card>
                                            <CardBody>
                                                <CardTitle>Prenota i Pranzi</CardTitle>
                                                <CardSubtitle>Da Rico's 3 La Forneria Venerdi' 29 Agosto, 2025 <br />
                                                     Prezzo: {PREZZI.RICOs_a}€ per adulti, {PREZZI.RICOs_b}€ per bambini</CardSubtitle>
                                                <FormGroup row>
                                                    <Label for="event1Adult" sm={6}>Numero di pasti adulti</Label>
                                                    <Col sm={6}><Input type="number" disabled={true} min="0" name="event1Adult" id="event1Adult"
                                                        onChange={(e) => { this.handleChange(e) }} value={this.state.event1Adult} /> 
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label for="event1Child" sm={6}>Numero di pasti per bambini</Label>
                                                    <Col sm={6}><Input type="number" disabled={true} min="0" name="event1Child" id="event1Child"
                                                        onChange={(e) => { this.handleChange(e) }} value={this.state.event1Child} />
                                                    </Col>
                                                </FormGroup>
                                                <CardSubtitle>Da Leo Ricci Sabato 30 Agosto, 2025 <br />
                                                    Prezzo: {PREZZI.LEO_a}€ per adulti, {PREZZI.LEO_b}€ per bambini</CardSubtitle>
                                                <FormGroup row>
                                                    <Label for="event2Adult" sm={6}>Numero di pasti adulti</Label>
                                                    <Col sm={6}><Input type="number" disabled={true} min="0" name="event2Adult" id="event2Adult"
                                                        onChange={(e) => { this.handleChange(e) }} value={this.state.event2Adult} />
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label for="event2Child" sm={6}>Numero di pasti per bambini</Label>
                                                    <Col sm={6}><Input type="number" disabled={true} min="0" name="event2Child" id="event2Child"
                                                        onChange={(e) => { this.handleChange(e) }} value={this.state.event2Child} />
                                                    </Col>
                                                </FormGroup>
                                                <CardSubtitle>Ristorante da Brun Domenica 31 Agosto, 2025 <br />
                                                    Prezzo: {PREZZI.BRUN_a}€ per adulti, {PREZZI.BRUN_b}€ per bambini</CardSubtitle>
                                                <FormGroup row>
                                                    <Label for="event3Adult" sm={6}>Numero di pasti adulti</Label>
                                                    <Col sm={6}><Input type="number" disabled={true} min="0" name="event3Adult" id="event3Adult"
                                                        onChange={(e) => { this.handleChange(e) }} value={this.state.event3Adult} />
                                                    </Col>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label for="event3Child" sm={6}>Numero di pasti bambini</Label>
                                                    <Col sm={6}><Input type="number" disabled={true} min="0" name="event3Child" id="event3Child"
                                                        onChange={(e) => { this.handleChange(e) }} value={this.state.event3Adult} />
                                                    </Col>
                                                </FormGroup>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                {/* <Row className="section-panel">
                                    <Col>
                                        <Card>
                                            <CardImg width="100%" src={piatto} alt="Card image cap" />
                                        </Card>
                                    </Col>
                                    <Col>
                                        <Card>
                                            <CardBody>
                                                <CardTitle>Piatto Commemorativo</CardTitle>
                                                <CardSubtitle>Prezzo: {PREZZI.DISH}€</CardSubtitle>
                                                <FormGroup row>
                                                    <Label for="countDish" sm={6}>Numero di piatti</Label>
                                                    <Col sm={6}><Input type="number" disabled={true} min="0" name="countDish" id="countDish"
                                                        onChange={(e) => { this.handleChange(e) }} value={this.state.countDish} />
                                                    </Col>
                                                </FormGroup>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row> */}
                                <Row className="section-panel">
                                    <Col>
                                        <Card>
                                            <CardImg width="100%" src={libro} alt="Card image cap" />
                                        </Card>
                                    </Col>
                                    <Col>
                                        <Card>
                                            <CardBody>
                                                <CardTitle>Libro del Clan Schiratti 2025</CardTitle>
                                                <CardSubtitle>Prezzo: {PREZZI.BOOK}€</CardSubtitle>
                                                <FormGroup row>
                                                    <Label for="countBook" sm={6}>Numero di libri</Label>
                                                    <Col sm={6}><Input type="number" disabled={true} min="0" name="countBook" id="countBook"
                                                        onChange={(e) => { this.handleChange(e) }} value={this.state.countBook} />
                                                    </Col>
                                                </FormGroup>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <ColoredLine color="#f1efd9" />
                                <Row>
                                    <Card className='confirmPanel'>
                                        <CardBody>
                                            <CardTitle>
                                                Costo indicativo della spesa
                                            </CardTitle>
                                            <Row>
                                                <Col><CardSubtitle>Prodotti</CardSubtitle></Col><Col><CardSubtitle>Totale</CardSubtitle></Col>
                                            </Row>
                                            {(this.state.event1Adult > 0) && (<Row>
                                                <Col><CardSubtitle>Numero di pasti per adulti a Rico's 3 La Forneria: {this.state.event1Adult}</CardSubtitle ></Col>
                                                <Col>{this.state.event1Adult * PREZZI.RICOs_a}€</Col>
                                            </Row>)}
                                            {(this.state.event1Child > 0) && (<Row>
                                                <Col><CardSubtitle>Numero di pasti per bambini a Rico's 3 La Forneria: {this.state.event1Child}</CardSubtitle ></Col>
                                                <Col>{this.state.event1Child * PREZZI.RICOs_b}€</Col>
                                            </Row>)}
                                            {(this.state.event2Adult > 0) && (<Row>
                                                <Col><CardSubtitle>Numero di pasti per adulti da Leo Ricci: {this.state.event2Adult}</CardSubtitle ></Col>
                                                <Col>{this.state.event2Adult * PREZZI.LEO_a}€</Col>
                                            </Row>)}
                                            {(this.state.event2Child > 0) && (<Row>
                                                <Col><CardSubtitle>Numero di pasti per bambini da Leo Ricci: {this.state.event2Child}</CardSubtitle ></Col>
                                                <Col>{this.state.event2Child * PREZZI.LEO_b}€</Col>
                                            </Row>)}
                                            {(this.state.event3Adult > 0) && (<Row>
                                                <Col><CardSubtitle>Numero di pasti per adulti da Brun: {this.state.event3Adult}</CardSubtitle ></Col>
                                                <Col>{this.state.event3Adult * PREZZI.BRUN_a}€</Col>
                                            </Row>)}
                                            {(this.state.event3Child > 0) && (<Row>
                                                <Col><CardSubtitle>Numero di pasti per bambini da Brun: {this.state.event3Child}</CardSubtitle ></Col>
                                                <Col>{this.state.event3Child * PREZZI.BRUN_b}€</Col>
                                            </Row>)}
                                            {/* {(this.state.countDish > 0) && (<Row>
                                                <Col><CardSubtitle>Numero di piatti commemorativi: {this.state.countDish}</CardSubtitle ></Col>
                                                <Col>{this.state.countDish * PREZZI.DISH}€</Col>
                                            </Row>)} */}
                                            {(this.state.countBook > 0) && (<Row>
                                                <Col><CardSubtitle>Numero di annuari: {this.state.countBook}</CardSubtitle ></Col>
                                                <Col>{this.state.countBook * PREZZI.BOOK}€</Col>
                                            </Row>)}
                                            <Row><Col><CardSubtitle>Totale</CardSubtitle></Col>
                                                <Col>
                                                        {(this.state.event1Adult * PREZZI.RICOs_a) +
                                                        (this.state.event1Child * PREZZI.RICOs_b) +
                                                        (this.state.event2Adult * PREZZI.LEO_a) +
                                                        (this.state.event2Child * PREZZI.LEO_b) +
                                                        (this.state.event3Adult * PREZZI.BRUN_a) +
                                                        (this.state.event3Adult * PREZZI.BRUN_b) +
                                                        // (this.state.countDish * PREZZI.DISH) +
                                                        (this.state.countBook * PREZZI.BOOK)
                                                    }€
                                                    </Col>
                                            </Row>
                                            <Button className='confirmButton' color="secondary" type="submit" disabled={true}>Conferma</Button>
                                        </CardBody>
                                    </Card>
                                </Row>
                            </Form>
                        );
                    }}
                </Mutation>
            </Container>
        );
    }
}